import React, { useState, useEffect } from "react";
import "../css/Header.css";

// Иконки Bootstrap
import { 
  ArrowRight,
  Rocket,
  Coin
} from "react-bootstrap-icons";

// Иконки криптовалют
import btc_icon from "../images/crypto/BTC.webp";
import eth_icon from "../images/crypto/ETH.png";
import xrp_icon from "../images/crypto/XRP.png";
import sol_icon from "../images/crypto/SOL.png";
import trumpImage from "../images/trump.png";

export const Header = () => {
  const [num, setNum] = useState(1);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const targetNum = 1000000000;
    const duration = 3000;
    const steps = 60;
    const increment = targetNum / steps;
    let current = 1;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      current = Math.floor(Math.pow(targetNum, step / steps));
      
      if (current >= targetNum || step >= steps) {
        setNum(targetNum);
        setIsComplete(true);
        clearInterval(timer);
      } else {
        setNum(current);
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, []);

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="box _header" id="main">
      <div className="container">
        <div className="col">
          <div className="text">
            {/* Картинка Трампа */}
            <img src={trumpImage} alt="Donald Trump" className="trump-image" />
            
            <h1>
              Make America a <br />
              <span>Crypto Giant</span> Again
            </h1>
            
            {/* Крипто-иконки */}
            <div className="crypto-icons">
              <div className="crypto-icon-item">
                <img src={btc_icon} alt="BTC" />
                <span className="crypto-amount">1,000</span>
              </div>
              <div className="crypto-icon-item">
                <img src={eth_icon} alt="ETH" />
                <span className="crypto-amount">10,000</span>
              </div>
              <div className="crypto-icon-item">
                <img src={xrp_icon} alt="XRP" />
                <span className="crypto-amount">100,000,000</span>
              </div>
              <div className="crypto-icon-item">
                <img src={sol_icon} alt="SOL" />
                <span className="crypto-amount">50,000,000</span>
              </div>
            </div>

            <p>
              During this unique event, you have the opportunity to take a share of 
              <span className="highlight-text"> 1,000 BTC</span>, 
              <span className="highlight-text"> 10,000 ETH</span>, 
              <span className="highlight-text"> 100,000,000 XRP</span> and 
              <span className="highlight-text"> 50,000,000 SOL</span>. 
              Have a look at the rules and don't miss out on this. 
              <strong> You can only participate once!</strong>
            </p>

            <a className="btn" href="#participate">
                <Rocket size={20} />
                <span>Participate Now</span>
                <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};